import { render } from "./testimonials.vue?vue&type=template&id=37436b64&scoped=true"
import script from "./testimonials.vue?vue&type=script&lang=js"
export * from "./testimonials.vue?vue&type=script&lang=js"

import "./testimonials.vue?vue&type=style&index=0&id=37436b64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37436b64"]])

export default __exports__